import React from "react";
import { ChapterRowUncompleted, Props } from "./ChapterRowUncompleted";

export default ({ story, chapter, user }: Omit<Props, "onComplete">) => {
  return <ChapterRowUncompleted story={story} chapter={chapter} user={user} />;
};
